import { gql } from "@apollo/client";

export default gql`
  query getAiGuidanceList($data: GetAiGuidanceListInput!){
    getAiGuidanceList(data: $data){
        success
        data{
            docs{
                _id
                customer
                title
                content
                category
                roles
                channel
                messageTypes
                toneOfVoice
                status
                createdAt
                updatedAt
            }
            totalDocs
            hasPrevPage
            hasNextPage
            page
            totalPages
        }
        code
        message
    }
}
`
